module.exports = __webpack_public_path__ + "static/media/3_Orient-Template-Straight.c41cc56f.svg";